module.exports = __webpack_public_path__ + "media/images/cover/4-e9d48b84e10598e79fdbc94614aa7c8f.png";